import { render, staticRenderFns } from "./SectionFields.vue?vue&type=template&id=df5bf778"
import script from "./SectionFields.ts?vue&type=script&lang=ts&external"
export * from "./SectionFields.ts?vue&type=script&lang=ts&external"
import style0 from "./SectionFields.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports